import type { ReactNode } from 'react';

interface SectionHeadProps {
  zone: string;
  title: string;
  desc?: string;
  extra?: ReactNode;
}

export default function SectionHead({ zone, title, desc, extra }: SectionHeadProps) {
  return (
    <div className="flex flex-col gap-4 border-b-2 border-foreground-950 pb-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="flex items-start gap-3">
        <span className="mt-1 shrink-0 rounded-sm bg-foreground-950 px-2 py-0.5 font-label text-[11px] font-bold tracking-wider text-background-50">
          {zone}
        </span>
        <div>
          <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">{title}</h3>
          {desc && <p className="mt-1.5 max-w-2xl font-body text-xs text-foreground-500 md:text-sm">{desc}</p>}
        </div>
      </div>
      {extra && <div className="lg:min-w-[360px]">{extra}</div>}
    </div>
  );
}